(function () {
  "use strict";
  if (window.SAEHomeGallery && window.SAEHomeGallery.version === 3) { window.SAEHomeGallery.initialize(); return; }
  var galleries = new Set(), queued = false;
  function fill(root) {
    var vertical = root.dataset.direction === "vertical";
    root.querySelectorAll(".sae-gallery-viewport").forEach(function (viewport) {
      var track = viewport.querySelector(".sae-gallery-track");
      if (!track || !track.firstElementChild) return;
      var first = track.firstElementChild;
      var bounds = first.getBoundingClientRect();
      var size = (vertical ? bounds.height : bounds.width) + (parseFloat(getComputedStyle(track).gap) || 0);
      if (!size) return;
      var extent = vertical ? viewport.clientHeight : viewport.clientWidth;
      var needed = Math.max(2, Math.min(120, Math.ceil(extent / size) + 2));
      while (track.children.length < needed) {
        var clone = first.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("inert", "");
        clone.querySelectorAll("a").forEach(function (a) { a.tabIndex = -1; });
        clone.querySelectorAll("img").forEach(function (img) { img.loading = "eager"; });
        clone.querySelectorAll("[data-shopify-editor-block]").forEach(function (block) { block.removeAttribute("data-shopify-editor-block"); });
        track.appendChild(clone);
      }
      while (track.children.length > needed) track.lastElementChild.remove();
    });
  }
  function placement() {
    document.querySelectorAll(".sae-gallery-home-hero").forEach(function (hero) { hero.classList.remove("sae-gallery-home-hero"); });
    document.querySelectorAll(".sae-gallery-home-visible").forEach(function (hero) { hero.classList.remove("sae-gallery-home-visible"); });
    var root = document.querySelector("[data-sae-home-gallery]");
    if (!root) return;
    var menu = document.querySelector(".main-menu");
    var hero = menu && menu.closest(".site-container");
    if (root.dataset.placement === "scroll") {
      if (hero) hero.classList.add("sae-gallery-home-hero");
      return;
    }
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var percent = Number(root.dataset.visibleHeight) || 32;
    var bottom = Number(root.dataset.visibleBottom);
    if (!Number.isFinite(bottom)) bottom = 64;
    var desired = Math.max(32, Math.min(viewportHeight * percent / 100, viewportHeight - bottom - 32));
    if (hero) {
      var bounds = menu.getBoundingClientRect();
      var contentBottom = bounds.bottom;
      var visibleChildren = Array.from(menu.children).map(function (child) { return child.getBoundingClientRect(); }).filter(function (rect) { return rect.height > 0 && rect.width > 0; });
      if (visibleChildren.length) contentBottom = Math.max.apply(Math, visibleChildren.map(function (rect) { return rect.bottom; }));
      var available = viewportHeight - bottom - contentBottom - 16;
      var shift = Math.min(Math.max(0, bounds.top - 16), Math.max(0, desired - available));
      var top = Math.max(16, bounds.top - shift);
      hero.style.setProperty("--sae-gallery-menu-top", top + "px");
      hero.style.setProperty("--sae-gallery-menu-max-height", Math.max(40, viewportHeight - bottom - desired - top - 16) + "px");
      hero.classList.add("sae-gallery-home-visible");
    }
    root.style.setProperty("--sae-gallery-visible-height", desired + "px");
    root.style.setProperty("--sae-gallery-visible-bottom", bottom + "px");
  }
  function refresh() { queued = false; placement(); galleries.forEach(fill); }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(refresh); } }
  var resizeObserver = typeof ResizeObserver === "function" ? new ResizeObserver(schedule) : null;
  function initialize() {
    galleries.forEach(function (root) {
      if (!root.isConnected) { galleries.delete(root); if (resizeObserver) resizeObserver.unobserve(root); }
    });
    document.querySelectorAll("[data-sae-home-gallery]").forEach(function (root) {
      if (galleries.has(root)) return;
      galleries.add(root); root.dataset.pageHidden = String(document.hidden);
      if (resizeObserver) resizeObserver.observe(root);
      root.querySelectorAll("img").forEach(function (img) { img.addEventListener("load", schedule); });
      var button = root.querySelector("[data-sae-gallery-pause]");
      if (button) {
        button.hidden = false;
        function update() {
          var paused = root.dataset.userPaused === "true" || root.dataset.autoScroll === "false";
          button.textContent = paused ? "Resume gallery" : "Pause gallery";
          button.setAttribute("aria-pressed", String(paused));
        }
        button.addEventListener("click", function () {
          if (root.dataset.autoScroll === "false") { root.dataset.autoScroll = "true"; root.dataset.userPaused = "false"; }
          else root.dataset.userPaused = String(root.dataset.userPaused !== "true");
          update();
        }); update();
      }
    });
    schedule();
  }
  window.SAEHomeGallery = { version: 3, initialize: initialize };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
  document.addEventListener("shopify:section:reorder", initialize);
  document.addEventListener("shopify:section:unload", function () { setTimeout(initialize, 0); });
  window.addEventListener("resize", schedule, { passive: true });
  document.addEventListener("visibilitychange", function () { galleries.forEach(function (root) { root.dataset.pageHidden = String(document.hidden); }); });
  if (document.fonts) document.fonts.ready.then(schedule);
  function editor(event, selected) {
    var root = event.target && (event.target.closest("[data-sae-home-gallery]") || event.target.querySelector("[data-sae-home-gallery]"));
    if (root) root.dataset.editorSelected = String(selected);
  }
  document.addEventListener("shopify:block:select", function (e) { editor(e, true); });
  document.addEventListener("shopify:block:deselect", function (e) { editor(e, false); });
  document.addEventListener("shopify:section:deselect", function (e) { editor(e, false); });
})();
